import { AccountOrders } from 'features/account/orders';
import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { useExposeMinimalCartExperiment } from 'experiments/use-enable-minimal-cart-experiment';
import { AccountOrders as LegacyAccountOrders } from 'pages/account/account-orders/account-orders';
import AuthRequired from 'pages/authentication/components/auth-required';

const AuthenticatedAccountOrdersPage = () => {
  const enableMinimalCartUi = useMinimalCartUi();
  useExposeMinimalCartExperiment();

  return enableMinimalCartUi ? <AccountOrders /> : <LegacyAccountOrders />;
};

export default function AccountOrdersRoute() {
  return (
    <AuthRequired>
      <AuthenticatedAccountOrdersPage />
    </AuthRequired>
  );
}
